export default __webpack_public_path__ + "750e967d9a758a0b6b77c71e11b21da7.svg";